export default {
  state: {
    map: null,
    loading: false,

    rodovias: false,
    dadosParana: false,
    active: null // Pesquisa Ativa: Sistema Rodoviário, Dados Paraná, etc.
  },
  getters: {
    map (state) {
      return state.map
    },
    loading (state) {
      return state.loading
    },
    rodovias (state) {
      return state.rodovias
    },
    dadosParana (state) {
      return state.dadosParana
    },
    active (state) {
      return state.active
    }
  },
  mutations: {
    setMap (state, map) {
      state.map = map
    },
    setLoading (state, loading) {
      state.loading = loading
    },
    setRodovias (state, rodovias) {
      state.rodovias = rodovias
    },
    setDadosParana (state, dadosParana) {
      state.dadosParana = dadosParana
    },
    setActive (state, active) {
      state.active = active
    }
  }
}
